import styles from 'components/Pages/PressReleases/FilterBarFunctional.module.scss';
import { Text } from '@sitecore-jss/sitecore-jss-nextjs';
import ArticleFilters from 'components/Functional/ArticleFilterBar/ArticleFilters';
import MobileBaseFilters from 'components/Functional/Filters/MobileFilter/MobileBaseFilters';
import SelectedFilters from 'components/Functional/ArticleFilterBar/SelectedFilters';
import { useEffect } from 'react';
import useSharedFiltersLogic from 'hooks/useSharedFiltersLogic';
import { articlesActions } from '@/store/articles';
import { useDispatch } from 'react-redux';

type OptionType = {
  aggregateCount: number;
  count: number;
  applied: boolean;
  disabled: boolean;
  selected: boolean;
  showAggregateCount: boolean;
  text: string;
};

type FormattedFiltersType = {
  displayName: string;
  displayNameKey: string;
  id: string;
  label: string;
  name: string;
  options: Array<OptionType>;
};

type Props = {
  e2eID: string;
  filterBarSubHeading: string;
  formattedFilters: Array<FormattedFiltersType>;
};

const TrustFinderFilterBar = ({ e2eID, filterBarSubHeading, formattedFilters }: Props) => {
  const {
    filterApply,
    filters,
    setFilters,
    allOptions,
    appliedFilters,
    appliedFilterOptions,
    selectedFilterOptions,
    onResetUnAppliedOptions,
    selectFilter,
    onClearFilters,
    getFiltersFromURL,
  } = useSharedFiltersLogic([]);
  const applicableFilters = formattedFilters.map((filter) => filter.id);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(articlesActions.setAppliedFilters(getFiltersFromURL(applicableFilters)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilters(formattedFilters);
  }, [formattedFilters, setFilters]);

  return (
    <div className="container pt-7 pb-5 background-white" id={e2eID}>
      <div className={`row ${styles['article-filter-bar-root']}`}>
        <div className="col-12">
          <div className="px-md-2 py-5 p-lg-5 background-digital-light-grey">
            <div className="d-flex align-items-start flex-column flex-md-row flex-lg-column">
              {filterBarSubHeading && (
                <Text tag="h4" field={{ value: filterBarSubHeading }} className="col-12 col-md-7" />
              )}

              {filters?.length !== 0 && (
                <>
                  <div className="col d-none d-lg-flex mt-4 mt-md-0">
                    <ArticleFilters
                      filters={filters}
                      loading={false}
                      onSelect={selectFilter}
                      onClearFilters={(filter) => onClearFilters(filter, 'multipleOptions')}
                      filterApply={filterApply}
                      onResetUnAppliedOptions={onResetUnAppliedOptions}
                      getFacets={() => {}}
                    />
                  </div>

                  <MobileBaseFilters
                    className="col-12 col-md-5 d-flex d-lg-none mt-4 mt-md-0 mt-lg-3"
                    buttonFullWidth
                    filters={filters}
                    isFetching={false}
                    allOptions={allOptions}
                    showDatePicker={false}
                    needAggregateCount={() => {}}
                    optionSelect={selectFilter}
                    resetUnAppliedOptions={onResetUnAppliedOptions}
                    filterApply={filterApply}
                    clearFilters={onClearFilters}
                    selectedOptions={selectedFilterOptions}
                  />
                </>
              )}

              {appliedFilters.length !== 0 && (
                <SelectedFilters
                  className="mt-4"
                  appliedFilterOptions={appliedFilterOptions}
                  onDeleteOption={(option) => onClearFilters(option, 'singleOption')}
                  onClearFilters={onClearFilters}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustFinderFilterBar;
